type ResolveSessionTeamIdArgs = {
  userId: string | undefined;
  teamId: string | null | undefined;
  fallbackTeamId: string | undefined;
  isFallbackTeamIdLoading: boolean;
};

type ResolveSessionTeamIdResult = {
  shouldFetchTeamId: boolean;
  resolvedTeamId: string | null | undefined;
  isBootstrappingTeamId: boolean;
};

type ResolveSessionTeamFetchingStateArgs = {
  isBootstrappingTeamId: boolean;
  isTeamQueryFetching: boolean;
};

type ResolveSessionTeamFetchingStateResult = {
  isApiTeamIdFetching: boolean;
  isSessionTeamFetching: boolean;
};

export const RECENT_TEAM_IDS_LIMIT = 5;

export const getRecentTeamIdsStorageKey = (userId: string) =>
  `${userId}_recent_tid`;

export const parseStoredRecentTeamIds = (value: string | null): string[] => {
  if (!value) return [];

  try {
    const parsed = JSON.parse(value);

    if (!Array.isArray(parsed)) return [];

    return parsed.filter((item): item is string => typeof item === 'string');
  } catch {
    return [];
  }
};

export const upsertRecentTeamId = ({
  teamId,
  recentTeamIds,
  limit = RECENT_TEAM_IDS_LIMIT,
}: {
  teamId: string | null | undefined;
  recentTeamIds: readonly string[];
  limit?: number;
}) => {
  if (!teamId) return [...recentTeamIds].slice(0, limit);

  return [teamId, ...recentTeamIds.filter((id) => id !== teamId)].slice(
    0,
    limit
  );
};

export const resolveSessionTeamId = ({
  userId,
  teamId,
  fallbackTeamId,
  isFallbackTeamIdLoading,
}: ResolveSessionTeamIdArgs): ResolveSessionTeamIdResult => {
  const shouldFetchTeamId =
    !!userId && (teamId === undefined || teamId === null);

  const resolvedTeamId =
    teamId ??
    fallbackTeamId ??
    (shouldFetchTeamId && !isFallbackTeamIdLoading ? null : undefined);

  const isBootstrappingTeamId = !!userId && resolvedTeamId === undefined;

  return {
    shouldFetchTeamId,
    resolvedTeamId,
    isBootstrappingTeamId,
  };
};

export const resolveSessionTeamFetchingState = ({
  isBootstrappingTeamId,
  isTeamQueryFetching,
}: ResolveSessionTeamFetchingStateArgs): ResolveSessionTeamFetchingStateResult => {
  return {
    isApiTeamIdFetching: isBootstrappingTeamId,
    isSessionTeamFetching: isBootstrappingTeamId || isTeamQueryFetching,
  };
};
